"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rdf_string_1 = require("rdf-string");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");

var sparqlee_1 = require("sparqlee");

var bus_query_operation_1 = require("@comunica/bus-query-operation");
/**
 * A comunica Filter Sparqlee Query Operation Actor.
 */


var ActorQueryOperationFilterSparqlee =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationFilterSparqlee, _bus_query_operation_);

  function ActorQueryOperationFilterSparqlee(args) {
    _classCallCheck(this, ActorQueryOperationFilterSparqlee);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationFilterSparqlee).call(this, args, 'filter'));
  }

  _createClass(ActorQueryOperationFilterSparqlee, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        var config, _;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Will throw error for unsupported operators
                config = {
                  exists: this.createExistenceResolver(context)
                };
                _ = new sparqlee_1.AsyncEvaluator(pattern.expression, config);
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(pattern, context) {
        var outputRaw, output, variables, metadata, expressionContext, config, evaluator, transform, bindingsStream;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.input,
                  context: context
                });

              case 2:
                outputRaw = _context3.sent;
                output = bus_query_operation_1.ActorQueryOperation.getSafeBindings(outputRaw);
                bus_query_operation_1.ActorQueryOperation.validateQueryOutput(output, 'bindings');
                variables = output.variables, metadata = output.metadata;
                expressionContext = bus_query_operation_1.ActorQueryOperation.getExpressionContext(context);
                config = Object.assign({}, expressionContext, {
                  exists: this.createExistenceResolver(context)
                });
                evaluator = new sparqlee_1.AsyncEvaluator(pattern.expression, config);

                transform =
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(item, next) {
                    var result;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return evaluator.evaluateAsEBV(item);

                          case 3:
                            result = _context2.sent;

                            if (result) {
                              bindingsStream._push(item);
                            }

                            _context2.next = 10;
                            break;

                          case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2["catch"](0);

                            if (!sparqlee_1.isExpressionError(_context2.t0)) {
                              bindingsStream.emit('error', _context2.t0);
                            }

                          case 10:
                            next();

                          case 11:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 7]]);
                  }));

                  return function transform(_x5, _x6) {
                    return _ref.apply(this, arguments);
                  };
                }();

                bindingsStream = output.bindingsStream.transform({
                  transform: transform
                });
                return _context3.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: metadata,
                  variables: variables
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }, {
    key: "createExistenceResolver",
    value: function createExistenceResolver(context) {
      var _this = this;

      return (
        /*#__PURE__*/
        function () {
          var _ref2 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4(expr, bindings) {
            var operation, outputRaw, output;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    operation = _this.substitute(expr.input, bindings);
                    _context4.next = 3;
                    return _this.mediatorQueryOperation.mediate({
                      operation: operation,
                      context: context
                    });

                  case 3:
                    outputRaw = _context4.sent;
                    output = bus_query_operation_1.ActorQueryOperation.getSafeBindings(outputRaw);
                    return _context4.abrupt("return", new Promise(function (resolve, reject) {
                      output.bindingsStream.on('end', function () {
                        resolve(false);
                      });
                      output.bindingsStream.on('error', reject);
                      output.bindingsStream.on('data', function () {
                        output.bindingsStream.close();
                        resolve(true);
                      });
                    }).then(function (exists) {
                      return expr.not ? !exists : exists;
                    }));

                  case 6:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x7, _x8) {
            return _ref2.apply(this, arguments);
          };
        }()
      );
    }
  }, {
    key: "substitute",
    value: function substitute(operation, bindings) {
      var _this2 = this;

      return sparqlalgebrajs_1.Util.mapOperation(operation, {
        path: function path(op, factory) {
          return {
            recurse: false,
            result: factory.createPath(_this2.substituteSingle(op.subject, bindings), op.predicate, _this2.substituteSingle(op.object, bindings), _this2.substituteSingle(op.graph, bindings))
          };
        },
        pattern: function pattern(op, factory) {
          return {
            recurse: false,
            result: factory.createPattern(_this2.substituteSingle(op.subject, bindings), _this2.substituteSingle(op.predicate, bindings), _this2.substituteSingle(op.object, bindings), _this2.substituteSingle(op.graph, bindings))
          };
        }
      });
    }
  }, {
    key: "substituteSingle",
    value: function substituteSingle(term, bindings) {
      if (term.termType === 'Variable') {
        return bindings.get(rdf_string_1.termToString(term), term);
      }

      return term;
    }
  }]);

  return ActorQueryOperationFilterSparqlee;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationFilterSparqlee = ActorQueryOperationFilterSparqlee;